import apiClient from "services/axios";

const API = {
  detail: "/api/v1/settings/default",
  update: "/api/v1/settings/default",
  getDatetime: "/api/v1/settings/datetime",
  setDatetime: "/api/v1/settings/datetime",
  shutdown: "/api/v1/settings/shutdown",
  factoryReset: "/api/v1/settings/factory-reset",
  factoryResetStatus: "/api/v1/settings/factory-reset-status",
  exportConfig: "/api/v1/settings/export",
  importConfig: "/api/v1/settings/import",
};

export const detail = async () => {
  const response = await apiClient.get(`${API.detail}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const update = async (body) => {
  let payload = body;
  if (body.logoFile) {
    payload = new FormData();
    payload.append("brandName", body.brandName);
    payload.append("logoFile", body.logoFile);
    payload.append("title", body.title);
  }
  const response = await apiClient.patch(`${API.update}`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (response) {
    return response.data;
  }
  return false;
};

export const getDatetime = async () => {
  const response = await apiClient.get(`${API.getDatetime}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const setDatetime = async (body) => {
  const response = await apiClient.put(API.setDatetime, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const shutdown = async () => {
  const response = await apiClient.post(API.shutdown);
  if (response) {
    return response.data;
  }
  return false;
};

export const factoryReset = async (body) => {
  const response = await apiClient.post(API.factoryReset, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const factoryResetStatus = async () => {
  const response = await apiClient.get(API.factoryResetStatus);
  if (response) {
    return response.data;
  }
  return false;
};

export const exportConfig = async () => {
  const response = await apiClient.get(`${API.exportConfig}`, { responseType: "blob" });
  if (response) {
    const href = URL.createObjectURL(response.data);

    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", "uSense.config");
    link.click();

    URL.revokeObjectURL(href);
    return true;
  }
  return false;
};

export const importConfig = async (body) => {
  let payload = body;
  if (body.configFile) {
    payload = new FormData();
    payload.append("configFile", body.configFile);
  }

  const response = await apiClient.post(API.importConfig, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (response) {
    return response.data;
  }
  return false;
};
